import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';

class Banner extends Component {
     constructor(props){
         super(props);
         this.state = {
             listItem: [
                 { id: 1, icon: 'fa fa-check', title: 'Discover the Latest State of the Art' },
                 { id: 2, icon: 'fa fa-check', title: '5 Chapters included' },
                 { id: 3, icon: 'fa fa-check', title: 'Hardcover and paperback versions' },
             ],
             amazonLinks: [
                 { country: "US", url: "https://www.amazon.com/dp/8409774860", flag: "us.png", currency: "USD" },
                 { country: "UK", url: "https://www.amazon.co.uk/dp/8409774860", flag: "gb.png", currency: "GBP" },
                 { country: "DE", url: "https://www.amazon.de/dp/8409774860", flag: "de.png", currency: "EUR" },
                 { country: "FR", url: "https://www.amazon.fr/dp/8409774860", flag: "fr.png", currency: "EUR" },
                 { country: "ES", url: "https://www.amazon.es/dp/8409774860", flag: "es.png", currency: "EUR" },
                 { country: "IT", url: "https://www.amazon.it/dp/8409774860", flag: "it.png", currency: "EUR" },
                 { country: "NL", url: "https://www.amazon.nl/dp/8409774860", flag: "nl.png", currency: "EUR" },
                 { country: "PL", url: "https://www.amazon.pl/dp/8409774860", flag: "pl.png", currency: "PLN" },
                 { country: "SE", url: "https://www.amazon.se/dp/8409774860", flag: "se.png", currency: "SEK" },
                 { country: "BE", url: "https://www.amazon.com.be/dp/8409774860", flag: "be.png", currency: "EUR" },
                 { country: "IE", url: "https://www.amazon.ie/dp/8409774860", flag: "ie.png", currency: "EUR" },
             ],

             showDropdown: false
         };
 
         this.dropdownRef = React.createRef();
     }   

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleDocumentClick = (e) => {
        if (!this.dropdownRef.current) return;
        if (this.state.showDropdown && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ showDropdown: false });
        }
    }

    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.showDropdown) {
            this.setState({ showDropdown: false });
        }
    }

    toggleDropdown = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState(prev => ({ showDropdown: !prev.showDropdown }));
    }

    handleAmazonClick = async (link, e) => {
      try {
        const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
          ? 'https://controlbook.onrender.com'
          : 'http://localhost:3000';
    
        await fetch(`${backendUrl}/clicks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "amazon-" + link.country.toLowerCase(),
            pageUrl: window.location.href,
            elementType: "link",
            userId: "user-react",
            coordinates: { x: 100, y: 200 },
            metadata: {
              country: link.country,
              currency: link.currency,
              store: "amazon",
              product: "neural-networks-book"
            }
          }),
        });
      } catch (err) {
        console.error('Error recording click', err);
      }
    
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-16832649503/ItwECMuR6ZIbEJ-yt9o-",
          value: 1.0,
          currency: link.currency,
        });
      }
      
      this.setState({ showDropdown: false });
    };

    handleLeanpubClick = async (event) => {
      try {
        const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
          ? 'https://controlbook.onrender.com'
          : 'http://localhost:3000';

        await fetch(`${backendUrl}/clicks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "leanpub-buy-digital",
            pageUrl: window.location.href,
            elementType: "button",
            userId: "user-react",
            coordinates: { x: event.clientX, y: event.clientY },
            metadata: {
              store: "leanpub",
              product: "neural-networks-book",
              type: "digital"
            }
          }),
        });
      } catch (err) {
        console.error('Error recording Leanpub click', err);
      }

      window.open("https://leanpub.com/neuralnetandadaptivecontrol", "_blank", "noopener noreferrer");
    };

    render() {
        return (
            <section className="banner pb-80">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-12 col-lg-6">
                            <div className="banner-content">
                                <span className="subheading">Exclusive Offer: 5% discount on early purchase</span>
                                <h1>From Theory to Practice: Adaptive Control with Neural Networks</h1>
                                <ul>
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={i}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>

                                {/* Amazon dropdown */}
                                <div className="dropdown mb-3" ref={this.dropdownRef}>
                                    <button
                                        className="btn btn-main dropdown-toggle"
                                        type="button"
                                        aria-haspopup="true"
                                        aria-expanded={this.state.showDropdown}
                                        onClick={this.toggleDropdown}
                                    >
                                        Buy on Amazon Print Version
                                    </button>

                                    <div
                                        className={`dropdown-menu ${this.state.showDropdown ? 'show' : ''}`}
                                        style={{ maxHeight: 300, overflowY: 'auto' }}
                                    >
                                        {this.state.amazonLinks.map((link) => (
                                            <a
                                                key={link.country}
                                                href={link.url}
                                                className="dropdown-item d-flex align-items-center"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => this.handleAmazonClick(link, e)}
                                            >
                                                <img
                                                    src={`https://flagcdn.com/w20/${link.flag}`}
                                                    alt={link.country}
                                                    style={{ width: 20, marginRight: 8 }}
                                                />
                                                <span>Amazon {link.country}</span>
                                            </a>
                                        ))}
                                    </div>
                                </div> 

                                {/* 🔴 Leanpub Button */}
                                <button                                
                                  className="btn btn-danger mb-3"
                                  onClick={this.handleLeanpubClick}
                                >
                                  Buy digital version on Leanpub
                                </button>

                                <p>
                                  Interested in a free chapter?{" "}
                                  <a
                                    href="/preview_merged.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(event) => {
                                      const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
                                        ? 'https://controlbook.onrender.com'
                                        : 'http://localhost:3000';
                                
                                      fetch(`${backendUrl}/clicks`, {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({
                                          sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                          elementId: "download-free-chapter",
                                          pageUrl: window.location.href,
                                          elementType: "link", 
                                          userId: "user-react",
                                          coordinates: { x: event.clientX, y: event.clientY },
                                          metadata: {
                                            document: "preview_merged.pdf",
                                            type: "free-chapter",
                                            action: "download"
                                          }
                                        }),
                                      }).catch(err => console.error('Error tracking click:', err));
                                    }}
                                  >
                                    Get it now
                                  </a>
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-5">
                            <div className="banner-img">
                                <img src="assets/images/banner/book.png" alt="" className="img-fluid"/>
                            </div>
                        </div>
                    </div> 
                </div> 
            </section>
        );
    }
}

export default Banner;
